module.exports = __webpack_public_path__ + "static/oficina_virtual.min-432ee8376fb64e972f3c1393dd08c511.png";